module.exports = __webpack_public_path__ + "img/rank-platinum.c8858af3.png";